import { render, staticRenderFns } from "./Layer.vue?vue&type=template&id=3b8d9a80"
import script from "./Layer.vue?vue&type=script&lang=js"
export * from "./Layer.vue?vue&type=script&lang=js"
import style0 from "./Layer.vue?vue&type=style&index=0&id=3b8d9a80&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports